import { render, staticRenderFns } from "./NewProseEditor.vue?vue&type=template&id=96193296&"
import script from "./NewProseEditor.vue?vue&type=script&lang=js&"
export * from "./NewProseEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewProseEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports